import { YAxisPercentTick } from './Ticks';
import YAxis from './YAxis';

export class YAxisPercent extends YAxis {
  static defaultProps = {
    ...YAxis.defaultProps,
    tick: YAxisPercentTick,
    type: 'number',
  };
}
